var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"km-module"},[_c('vue-tel-input',{attrs:{"valid-characters-only":true,"style-classes":[
      'form-control',
      _vm.isDirty && (_vm.isValid ? 'is-valid' : 'is-invalid')
    ],"name":"tel","only-countries":_vm.countryList,"dropdown-options":_vm.countryList.length === 1 && _vm.countryList.includes(_vm.defaultCountry)
        ? {
            disabled: true,
            showFlags: true
          }
        : undefined,"input-options":{ placeholder: _vm.placeholder },"default-country":_vm.defaultCountry},on:{"country-changed":_vm.countryChanged,"validate":_vm.validate,"focus":function($event){_vm.isFocus = true},"input":_vm.input},model:{value:(_vm.innerTel),callback:function ($$v) {_vm.innerTel=$$v},expression:"innerTel"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }